import { useState } from "react";
import { EventModel } from "../models/EventModel";

let _events: EventModel[] = [];

export function useEvents() {
  
    const [events, setEvents] = useState<EventModel[]>(_events);

    const updateEvents = (newEvents: EventModel[]) => {
        _events = [...newEvents];
        setEvents([...newEvents]);
    }

    return [
        events,
        updateEvents
    ] as const;

}
